import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background-50">
      <div className="w-24 h-24 rounded-full bg-primary-100 flex items-center justify-center mb-6">
        <i className="ri-emotion-sad-line text-4xl text-primary-500"></i>
      </div>
      <h1 className="text-4xl md:text-6xl font-heading font-bold text-foreground-900 mb-3">404</h1>
      <p className="text-lg text-foreground-500 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-400 mb-8">抱歉，您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
      >
        <i className="ri-home-4-line"></i>
        返回首页
      </Link>
    </div>
  );
}